type Vector3 = Pick<IVector3D, 'X' | 'Y' | 'Z'>;

interface PanoCameraState {
    yaw: number;
    pitch: number;
    fov: number;
}

const CAMERA_EPSILON = 0.0001;

const nearlyEqual = (left: number | null | undefined, right: number | null | undefined) =>
    typeof left === 'number'
    && typeof right === 'number'
    && Math.abs(left - right) <= CAMERA_EPSILON;

const vectorsMatch = (left: Vector3 | null | undefined, right: Vector3 | null | undefined) =>
    !!left
    && !!right
    && nearlyEqual(left.X, right.X)
    && nearlyEqual(left.Y, right.Y)
    && nearlyEqual(left.Z, right.Z);

export const hasPanoCameraChanged = (
    displayProperties: IDisplayProperties | null | undefined,
    camera: PanoCameraState,
) => !nearlyEqual(displayProperties?.Yaw, camera.yaw)
    || !nearlyEqual(displayProperties?.Pitch, camera.pitch)
    || !nearlyEqual(displayProperties?.Fov, camera.fov);

export const has3DCameraChanged = (
    displayProperties: IDisplayProperties | null | undefined,
    position: Vector3,
    target: Vector3,
) => !vectorsMatch(displayProperties?.CameraPosition, position)
    || !vectorsMatch(displayProperties?.CameraTarget, target);

export const shouldMark3DCameraDirty = (
    displayProperties: IDisplayProperties | null | undefined,
    position: Vector3,
    target: Vector3,
    isKnowledgeViewCameraRestoreInProgress: boolean,
    hasRecentUserCameraInteraction: boolean,
) => !isKnowledgeViewCameraRestoreInProgress
    && hasRecentUserCameraInteraction
    && has3DCameraChanged(displayProperties, position, target);
